import NavActionTypes from "./nav.types";

export const scrollToSection = (section) => ({
  type: NavActionTypes.SCROLL_TO_SECTION,
  payload: section,
});

export const setOverGallery = (isOver) => ({
  type: NavActionTypes.SET_OVER_GALLERY,
  payload: isOver,
});
